import { AI_API_SERVICE } from '@eggplant/api-hosts'
import { AuthenticatedPolling } from '@eggplant/data-request'
import type {
  Error,
  GetAiModelResponse
} from '@eggplant/types'
import type { ReactElement } from 'react'

interface Props {
  onError?: (error: Error) => void
  onSuccess?: (response: GetAiModelResponse) => void
  children?: (response: GetAiModelResponse) => ReactElement
  shortErrorMessage?: string
  id: string
  isPolling: boolean
  intervalMs?: number
}

const PollAiModelRequest = ({
  onError,
  onSuccess,
  children,
  shortErrorMessage,
  id,
  isPolling,
  intervalMs = 5000
}: Props) => {
  const url = `${AI_API_SERVICE}/models/${id}`

  return (
    <AuthenticatedPolling<GetAiModelResponse>
      children={children}
      intervalMs={intervalMs}
      isPolling={isPolling}
      onError={onError}
      onSuccess={onSuccess}
      shortErrorMessage={shortErrorMessage}
      url={url}
    />
  )
}

export default PollAiModelRequest
